<tt-header class="tt-app_header" id="tt-header" />

<router-outlet />

<ngx-sonner-toaster
  closeButton
  offset="4.5rem"
  position="bottom-center"
  richColors
  [attr.data-testid]="'sonner-toaster_info'"
/>
